<template>
  <v-container fluid>
    <v-dialog
        v-model="editDialog"
        max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Редактирование данных</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.amount"
                    label="Количество"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.price"
                    label="Цена"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4"
              >
                <v-text-field
                    v-model="editedItem.dealerPrice"
                    label="Дилерская цена"
                ></v-text-field>
              </v-col>
              <v-col cols="12"
                     sm="6"
                     md="4">
                <v-select :items="selects" label="Для продажи" dense />
              </v-col>
              <v-col cols="12"
                     sm="6"
                     md="4">
                <v-select :items="selects" label="Скрыть" dense />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="close"
          >
            Отмена
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="save"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Панель фильтров -->
    <v-card class="mb-4">
      <v-card-title>
        Каталог запчастей
      </v-card-title>
    </v-card>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Фильтры
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-select v-model="filters.brandId" :items="spareBrands" item-value="id" item-text="name" label="Бренд" outlined dense persistent-hint multiple />
            </v-col>
            <v-col cols="12" class="d-flex justify-start">
              <v-btn color="primary" @click="getData" class="mr-2">Применить</v-btn>
              <v-btn text @click="resetFilters">Сбросить</v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card class="mt-6">
      <v-data-table
          :headers="headers"
          :items="data"
          :items-per-page="size"
          :server-items-length="totalElements"
          :options.sync="options"
          :multi-sort="false"
          class="elevation-1"
          :footer-props="{
            'items-per-page-text': 'Строк на странице:',
            'items-per-page-options': [5, 10, 20, 50]
          }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-col>
<!--                <v-btn-->
<!--                    @click="addTire"-->
<!--                    depressed-->
<!--                    color="primary"-->
<!--                >-->
<!--                  <v-icon-->
<!--                      left-->
<!--                      dark-->
<!--                  >-->
<!--                    mdi-plus-->
<!--                  </v-icon>-->
<!--                  Добавить запчасть-->
<!--                </v-btn>-->
              </v-col>
              <v-col cols="3">
                <v-text-field
                    @input="search"
                    v-model="searchText"
                    label="Поиск"
                    outlined
                    dense
                    hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="editItem(item)" fab color="primary" small>
            <v-icon>
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-btn @click="deleteItem(item)" fab color="warning" class="mx-2" small>
            <v-icon>
              mdi-delete
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import {showSnackbar} from "@/plugins/eventBus";

export default {
  name: 'AdminSpareCatalog',
  data() {
    return {
      selects: ['Да', 'Нет'],
      editedItem: {
        amount: null,
        price: null,
        dealerPrice: null,
      },
      editDialog: false,
      searchText: '',
      filters: {
        brandId: null,
      },
      data: [],
      spareBrands: [],
      size: 10,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Наименование', value: 'name' },
        { text: 'Артикул', value: 'vendorCode' },
        { text: 'Бренд', value: 'brandName' },
        { text: 'Действия', value: 'actions' },
      ],
      totalElements: 0,
      options: {}
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  },
  mounted() {
    this.getData()
    this.getSpareBrands()
  },
  methods: {
    close () {
      this.editDialog = false
      this.editedItem = {
        amount: null,
        price: null,
        dealerPrice: null,
      }
    },
    async save () {
      console.log(this.editedItem)
      this.editedItem.tireId = this.editedItem.id
      const data = {
        amount: parseInt(this.editedItem.amount),
        price: parseInt(this.editedItem.price),
        dealerPrice: parseInt(this.editedItem.dealerPrice),
        sharePartId: this.editedItem.id,
        isForSale: this.editedItem.isForSale === 'Да',
        isHidden: this.editedItem.isHidden === 'Да',
      }
      try {
        await this.$store.dispatch('partnerSpare/addPartnerSpare', data)
        showSnackbar({
          message: "Успешно дабавлено!",
          color: "success",
          timeout: 3000,
        })
      } catch (e) {
        showSnackbar({
          message: "Неудалось добавить!",
          color: "warning",
          timeout: 3000,
        })
      }
      this.editDialog = false
      this.editedItem = {
        amount: null,
        price: null,
        dealerPrice: null,
      }
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
    },
    addTire () {
      this.$router.push('/partner/spare/add')
    },
    search () {
      this.getData()
    },
    async getData () {
      console.log(this.options)
      const sortBy = this.options.sortBy && this.options.sortBy.length > 0 ? this.options.sortBy[0] : ''
      const ascOrDesc = sortBy ? this.options.sortDesc.length > 0 ? (this.options.sortDesc[0] ? 'desc' : 'asc') : '' : ''
      const data = {
        size: this.options['itemsPerPage'],
        page: this.options['page'] - 1,
      }
      if (this.filters.brandId) {
        data.brandId = this.filters.brandId.join(',')
      }
      if (sortBy) {
        data.orderBy = sortBy
        data.ascOrDesc = ascOrDesc
      }
      if (this.searchText) {
        data.name = this.searchText
      }
      try {
        const resp = await this.$store.dispatch('adminSpareController/getSparesCatalog', data)
        this.data = resp.list
        this.totalElements = resp.totalElements
      } catch (e) {
        console.log(e)
      }
    },
    async getSpareBrands() {
      try {
        this.spareBrands = await this.$store.dispatch('adminSpareController/getSpareBrands')
        console.log(this.tireBrands)
      } catch (e) {
        console.log(e)
      }
    },
    resetFilters() {
      this.filters = {
        brandId: null,
      }
      this.getData()
    }
  }
}
</script>
<style scoped>

</style>